module.exports = __webpack_public_path__ + "img/Property 1=4x3, Property 2=PW - Palau.0f3f19f1.svg";